module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "base"
  }, [_vm._t("default"), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "footer",
    attrs: {
      "role": "region",
      "aria-label": "תחתית הדף",
      "id": "footerC"
    }
  }, [_c('div', {
    staticClass: "back-yards-credit"
  }, [_c('div', {
    staticClass: "footer-logo"
  }, [_c('div', {
    staticClass: "footer-logo-img"
  }, [_c('img', {
    staticClass: "fillImg",
    attrs: {
      "alt": "החצר",
      "src": "images/site-bottom-logo.png"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/yardbands"
    }
  }, [_c('div', {
    staticClass: "footer-social",
    attrs: {
      "id": "social1"
    }
  }, [_c('img', {
    staticClass: "fillImg",
    attrs: {
      "alt": "החצר בפייסבוק",
      "src": "images/social1.png"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.instagram.com/yardbands"
    }
  }, [_c('div', {
    staticClass: "footer-social",
    attrs: {
      "id": "social2"
    }
  }, [_c('img', {
    staticClass: "fillImg",
    attrs: {
      "alt": "החצר באינסטגרם",
      "src": "images/social2.png"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.youtube.com/channel/UCSbxr9Lhw29M_cVdDDsW8EA/playlists"
    }
  }, [_c('div', {
    staticClass: "footer-social",
    attrs: {
      "id": "social3"
    }
  }, [_c('img', {
    staticClass: "fillImg",
    attrs: {
      "alt": "החצר ביוטיוב",
      "src": "images/social3.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "contacts"
  }, [_c('p', [_c('strong', [_vm._v("\n\t\t\t\t\tליצירת קשר "), _c('a', {
    attrs: {
      "href": "tel:0547737094"
    }
  }, [_vm._v("054-7737094")]), _vm._v("\n\t\t\t\t\t | "), _c('a', {
    attrs: {
      "href": "mailto:OFFICE@YARDBANDS.COM"
    }
  }, [_vm._v("OFFICE@YARDBANDS.COM")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tכל הזכויות שמורות לחצר\n\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://yard-bands.herokuapp.com/privacyPolicy.pdf"
    }
  }, [_c('strong', [_vm._v("מדיניות פרטיות")])]), _vm._v("|\n\t\t\t\t\t"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://yard-bands.herokuapp.com/privacyPolicy.pdf"
    }
  }, [_c('strong', [_vm._v("תנאי שימוש")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "credits",
    attrs: {
      "role": "navigation",
      "aria-label": "קרדיט"
    }
  }, [_c('p', [_c('strong', [_c('a', {
    staticStyle: {
      "color": "#FF632B"
    },
    attrs: {
      "href": "https://www.designninjas.org"
    }
  }, [_vm._v("DESIGN: DOVEV ALPERSON (DESIGN NINJAS)")]), _vm._v(" | CODE BY YUVAL DERI (FUTURE CACHET) | PHOTOGRAPY BY ILAN BURLA")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49db4088!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Origami.vue
// module id = 114
// module chunks = 0